import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from '@/layouts/AdminLayout';
import DashboardPage from '@/pages/DashboardPage';
import SitePage from '@/pages/SitePage';
import CategoryPage from '@/pages/CategoryPage';
import LoginPage from '@/pages/LoginPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="sites/:siteSlug" element={<SitePage />} />
        <Route path="sites/:siteSlug/:categorySlug" element={<CategoryPage />} />
      </Route>
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
